import {
  Image,
  InfoBanner,
  Paragraph,
  Title,
} from '@dynamo-caffeina-dev/airc-ui-kit'
import NextImage from 'next/image'
import {
  ImageProps,
  InfoBannerProps,
  ParagraphProps,
  TitleProps,
} from '@/types'

export interface RecipeStepProps {
  title: TitleProps
  infoBanner: InfoBannerProps
  image: ImageProps & { image: ImageProps }
  paragraph: ParagraphProps
  content?: any
  className?: string
}

export interface RecipeStepRepeaterProps {
  content: RecipeStepProps[]
  className?: string
}

function RecipeStepRepeater({ content, className }: RecipeStepRepeaterProps) {
  console.info('ℹ️ [Calling RecipeStepsRepeater]')
  const renderRecipeSteps = () => {
    return content.map((step, index) => {
      return (
        <RecipeStep
          key={index}
          className={className}
          {...step}
        />
      )
    })
  }
  return (
    <div className={`recipe-steps-repeater ${className}`}>
      {renderRecipeSteps()}
    </div>
  )
}

function RecipeStep({
  title,
  infoBanner,
  image: _image,
  paragraph,
  className,
}: RecipeStepProps) {
  const titleLabel = title.content ?? ''
  const infoBannerLabel = infoBanner.content ?? ''
  const { fit, image } = _image ?? {}
  const { alt_text, caption, name, url } = image ?? {}
  let imageProps = null

  if (url) {
    imageProps = {
      src: url,
      alt: alt_text || caption || name || '',
      width: image.width || 400,
      height: image.height || 400,
    }
  }
  const paragraphContent = paragraph.content ?? ''

  return (
    <section className={`recipe-step ${className}__step`}>
      {titleLabel ? (
        <Title
          className='recipe-step__title'
          {...title}
          dangerouslySetInnerHTML={{ __html: titleLabel }}
        />
      ) : null}
      {infoBannerLabel ? (
        <InfoBanner
          className='recipe-step__info-banner'
          {...(infoBanner ?? {})}
          icon={infoBanner?.icon}
        >
          {infoBannerLabel}
        </InfoBanner>
      ) : null}
      {image && imageProps?.src ? (
        <Image
          fit={fit}
          className={`recipe-step__image`}
          as={NextImage}
          imageProps={imageProps}
        />
      ) : null}
      {paragraphContent ? (
        <Paragraph
          className={`recipe-step__paragraph`}
          {...paragraph}
          dangerouslySetInnerHTML={{ __html: paragraphContent }}
        />
      ) : null}
    </section>
  )
}

export default RecipeStepRepeater
